<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Klasifikasi'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'classifications'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/classifications/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        description: ''
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Klasifikasi", route: "" },
      { title: "Daftar Klasifikasi", route: "/masters/classifications/list" },
      { title: "Tambah" },
    ])
  },

}

</script>